
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import analytics from './utils/analytics';
import errorMonitoring from './utils/errorMonitoring';
import { generateUniqueNickname } from './utils/nicknameGenerator';

// Render the app immediately
ReactDOM.createRoot(document.getElementById('root')!).render(
  // Disable StrictMode in production to prevent double initialization
  import.meta.env.DEV ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  ),
);

// Defer non-critical initialization
setTimeout(() => {
  // Initialize analytics and error monitoring
  analytics.init();
  errorMonitoring.init();

  // Log environment information in development
  if (import.meta.env.DEV) {
    console.log('Running in development mode');
  } else {
    console.log('Running in production mode');
  }

  // Generate and set user nickname if not already set
  const userNickname = localStorage.getItem('user_nickname');
  if (!userNickname) {
    const newNickname = generateUniqueNickname();
    localStorage.setItem('user_nickname', newNickname);
    
    // Use a random ID for anonymous users
    const userId = 'user_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('user_id', userId);
    
    // Set user info in analytics
    analytics.setUserInfo(userId, newNickname);
    
    console.log(`Generated nickname: ${newNickname}`);
  } else {
    const userId = localStorage.getItem('user_id') || 
                  'user_' + Math.random().toString(36).substring(2, 15);
    
    // Set user info in analytics
    analytics.setUserInfo(userId, userNickname);
  }
}, 0);
